
import { mapMutations, mapState } from 'vuex';
import PrimaryButton from '@/components/ui/primaryButton.vue';

export default {
  name: 'MbwayPending',

  components: {
    PrimaryButton,
  },

  data() {
    return {
      time: 60 * 1000 * 5,
      interval: null,
    };
  },

  computed: {
    timer() {
      const minutes = Math.floor(this.time / 60000);
      const seconds = ((this.time % 60000) / 1000).toFixed(0);
      return `${minutes} : ${seconds < 10 ? '0' : ''}${seconds}`;
    },
    ...mapState(['kwanzaQr']),
  },

  watch: {
    time(value) {
      if (value < 1000) {
        clearInterval(this.interval);
        this.setEKwanzaPending({ pending: false, qr: null });
      }
    },
  },

  beforeMount() {
    document.body.classList.add('no-scroll');
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    document.body.classList.remove('no-scroll');
  },

  methods: {
    ...mapMutations(['setEKwanzaPending']),

    startTimer() {
      this.interval = setInterval(() => {
        this.time = this.time - 1000;
      }, 1000);
    },
  },
};
